import MenuItem from '@mui/material/MenuItem'
import { useCountryContext } from 'store/useCountryContext'
import { Country } from 'utils/api/country'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

type Props = {
  onClick: () => void
  c: Country
}

export const CountryItem = ({ c, onClick }: Props) => {
  const name = useGetObjectTranslation(c?.translation, 'name')
  const { country } = useCountryContext()

  return (
    <MenuItem data-cy={`country-${c.id}`} key={c.id} onClick={onClick} selected={country.id === c.id}>
      {name}
    </MenuItem>
  )
}
